import canUseMedia from './canUseMedia'

export default function isMobile() {
  return canUseMedia && window.matchMedia('(max-width: 767px)').matches
}
